 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CONTENTCONTENT0005 from '@/components/content/content0005'
 import CONTENTCONTENT0007 from '@/components/content/content0007'
 import CONTENTCONTENT0010 from '@/components/content/content0010'
 import CONTENTCONTENT0014 from '@/components/content/content0014'
 import CONTENTCONTENT0018 from '@/components/content/content0018'
 import CONTENTCONTENT0022 from '@/components/content/content0022'
 import CONTENTCONTENT0025 from '@/components/content/content0025'
 import CONTENTCONTENT0028 from '@/components/content/content0028'
 import CONTENTCONTENT0031 from '@/components/content/content0031'
 import CONTENTCONTENT0034 from '@/components/content/content0034'
 import CONTENTCONTENT0037 from '@/components/content/content0037'
 import CONTENTCONTENT0039 from '@/components/content/content0039'
 import CONTENTCONTENT0042 from '@/components/content/content0042'
 import CONTENTCONTENT0046 from '@/components/content/content0046'
 import CONTENTCONTENT0048 from '@/components/content/content0048'
 import CONTENTCONTENT0052 from '@/components/content/content0052'
 import CONTENTCONTENT0056 from '@/components/content/content0056'
 import CONTENTCONTENT0059 from '@/components/content/content0059'
 import CONTENTCONTENT0062 from '@/components/content/content0062'
 import CONTENTCONTENT0065 from '@/components/content/content0065'
 import CONTENTCONTENT0069 from '@/components/content/content0069'
 import CONTENTCONTENT0072 from '@/components/content/content0072'
 import CONTENTCONTENT0075 from '@/components/content/content0075'
 import CONTENTCONTENT0080 from '@/components/content/content0080'
 import CONTENTCONTENT0083 from '@/components/content/content0083'
 import CONTENTCONTENT0086 from '@/components/content/content0086'
 import CONTENTCONTENT0089 from '@/components/content/content0089'
 import CONTENTCONTENT0092 from '@/components/content/content0092'
 import CONTENTCONTENT0095 from '@/components/content/content0095'
 import CONTENTCONTENT0097 from '@/components/content/content0097'
 import CONTENTCONTENT0100 from '@/components/content/content0100'
 import CONTENTCONTENT0103 from '@/components/content/content0103'
 import CONTENTCONTENT0106 from '@/components/content/content0106'
 import CONTENTCONTENT0108 from '@/components/content/content0108'
 import CONTENTCONTENT0110 from '@/components/content/content0110'
 import CONTENTCONTENT0113 from '@/components/content/content0113'
 import CONTENTCONTENT0115 from '@/components/content/content0115'
 import CONTENTCONTENT0118 from '@/components/content/content0118'
 import CONTENTCONTENT0121 from '@/components/content/content0121'
 import CONTENTCONTENT0124 from '@/components/content/content0124'
 import CONTENTCONTENT0127 from '@/components/content/content0127'
 import CONTENTCONTENT0129 from '@/components/content/content0129'
 import CONTENTCONTENT0133 from '@/components/content/content0133'
 import CONTENTCONTENT0136 from '@/components/content/content0136'
 import CONTENTCONTENT0139 from '@/components/content/content0139'
 import CONTENTCONTENT0142 from '@/components/content/content0142'
 import CONTENTCONTENT0144 from '@/components/content/content0144'
 import CONTENTCONTENT0148 from '@/components/content/content0148'
 import CONTENTCONTENT0151 from '@/components/content/content0151'
 import CONTENTCONTENT0154 from '@/components/content/content0154'
 import CONTENTCONTENT0156 from '@/components/content/content0156'
 import CONTENTCONTENT0158 from '@/components/content/content0158'
 import CONTENTCONTENT0161 from '@/components/content/content0161'
 import CONTENTCONTENT0164 from '@/components/content/content0164'
 import CONTENTCONTENT0166 from '@/components/content/content0166'
 import CONTENTCONTENT0168 from '@/components/content/content0168'
 import CONTENTCONTENT0171 from '@/components/content/content0171'
 import CONTENTCONTENT0174 from '@/components/content/content0174'
 import CONTENTCONTENT0177 from '@/components/content/content0177'
 import CONTENTCONTENT0180 from '@/components/content/content0180'
 import CONTENTCONTENT0183 from '@/components/content/content0183'
 import CONTENTCONTENT0186 from '@/components/content/content0186'
 import CONTENTCONTENT0189 from '@/components/content/content0189'
 import CONTENTCONTENT0191 from '@/components/content/content0191'
 import CONTENTCONTENT0193 from '@/components/content/content0193'
 import CONTENTCONTENT0196 from '@/components/content/content0196'
 import CONTENTCONTENT0199 from '@/components/content/content0199'
 import CONTENTCONTENT0201 from '@/components/content/content0201'
 import CONTENTCONTENT0204 from '@/components/content/content0204'
 import CONTENTCONTENT0207 from '@/components/content/content0207'
 import CONTENTCONTENT0210 from '@/components/content/content0210'
 import CONTENTCONTENT0213 from '@/components/content/content0213'
 import CONTENTCONTENT0218 from '@/components/content/content0218'
 import CONTENTCONTENT0221 from '@/components/content/content0221'
 import CONTENTCONTENT0224 from '@/components/content/content0224'
 import CONTENTCONTENT0227 from '@/components/content/content0227'
 import CONTENTCONTENT0230 from '@/components/content/content0230'
 import CONTENTCONTENT0233 from '@/components/content/content0233'
 import CONTENTCONTENT0236 from '@/components/content/content0236'
 import CONTENTCONTENT0239 from '@/components/content/content0239'
 import CONTENTCONTENT0242 from '@/components/content/content0242'
 import CONTENTCONTENT0245 from '@/components/content/content0245'
 import CONTENTCONTENT0248 from '@/components/content/content0248'
 import CONTENTCONTENT0250 from '@/components/content/content0250'
 import CONTENTCONTENT0253 from '@/components/content/content0253'
 import CONTENTCONTENT0256 from '@/components/content/content0256'
 import CONTENTCONTENT0259 from '@/components/content/content0259'
 import CONTENTCONTENT0262 from '@/components/content/content0262'
 import CONTENTCONTENT0265 from '@/components/content/content0265'
 import CONTENTCONTENT0268 from '@/components/content/content0268'
 import CONTENTCONTENT0271 from '@/components/content/content0271'
 import CONTENTCONTENT0273 from '@/components/content/content0273'
 import CONTENTCONTENT0275 from '@/components/content/content0275'
 import CONTENTCONTENT0278 from '@/components/content/content0278'
 import CONTENTCONTENT0281 from '@/components/content/content0281'
 import CONTENTCONTENT0284 from '@/components/content/content0284'
 import CONTENTCONTENT0287 from '@/components/content/content0287'
 import CONTENTCONTENT0290 from '@/components/content/content0290'
 import CONTENTCONTENT0292 from '@/components/content/content0292'
 import CONTENTCONTENT0295 from '@/components/content/content0295'
 import CONTENTCONTENT0298 from '@/components/content/content0298'
 import CONTENTCONTENT0302 from '@/components/content/content0302'
 import CONTENTCONTENT0305 from '@/components/content/content0305'
 import CONTENTCONTENT0307 from '@/components/content/content0307'
 import CONTENTCONTENT0309 from '@/components/content/content0309'
 import CONTENTCONTENT0311 from '@/components/content/content0311'
 import CONTENTCONTENT0314 from '@/components/content/content0314'
 import CONTENTCONTENT0317 from '@/components/content/content0317'
 import CONTENTCONTENT0319 from '@/components/content/content0319'
 import CONTENTCONTENT0321 from '@/components/content/content0321'
 import CONTENTCONTENT0324 from '@/components/content/content0324'
 import CONTENTCONTENT0326 from '@/components/content/content0326'
 import CONTENTCONTENT0329 from '@/components/content/content0329'
 import CONTENTCONTENT0332 from '@/components/content/content0332'
 import CONTENTCONTENT0335 from '@/components/content/content0335'
 import CONTENTCONTENT0338 from '@/components/content/content0338'
 import CONTENTCONTENT0344 from '@/components/content/content0344'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content/content0005",
 			"name" : "content/content0005",
 			"component" : CONTENTCONTENT0005
 		},
 		{
 			"path" : "/content/content0007",
 			"name" : "content/content0007",
 			"component" : CONTENTCONTENT0007
 		},
 		{
 			"path" : "/content/content0010",
 			"name" : "content/content0010",
 			"component" : CONTENTCONTENT0010
 		},
 		{
 			"path" : "/content/content0014",
 			"name" : "content/content0014",
 			"component" : CONTENTCONTENT0014
 		},
 		{
 			"path" : "/content/content0018",
 			"name" : "content/content0018",
 			"component" : CONTENTCONTENT0018
 		},
 		{
 			"path" : "/content/content0022",
 			"name" : "content/content0022",
 			"component" : CONTENTCONTENT0022
 		},
 		{
 			"path" : "/content/content0025",
 			"name" : "content/content0025",
 			"component" : CONTENTCONTENT0025
 		},
 		{
 			"path" : "/content/content0028",
 			"name" : "content/content0028",
 			"component" : CONTENTCONTENT0028
 		},
 		{
 			"path" : "/content/content0031",
 			"name" : "content/content0031",
 			"component" : CONTENTCONTENT0031
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js